import { API_URLS } from "../../../../../../Constants/api.constants";
import { toDateTimeISOStringFormat } from "../../../../../../Services/string.service";

export const buildPositionsQuery = ({
  vehicleId,
  groupId,
  startDate,
  endDate,
  onlyEvents,
  pageNumber,
  pageSize,
  lastReceived,
}) => {
  const params = new URLSearchParams();

  if (vehicleId != null) params.append("VehicleId", vehicleId);
  if (groupId != null) params.append("GroupId", groupId);
  if (startDate) params.append("StartDate", startDate);
  if (endDate) params.append("EndDate", endDate);

  const normalizedEvents = `${onlyEvents ?? ""}`.trim().toUpperCase();
  if (normalizedEvents && normalizedEvents !== "N")
    params.append("OnlyEvents", onlyEvents);

  if (pageNumber != null) params.append("PageNumber", pageNumber);
  if (pageSize != null) params.append("PageSize", pageSize);
  if (lastReceived) params.append("LastReceived", lastReceived);

  return params.toString();
};

export const formatDateForQuery = (date) => {
  if (!date) return null;
  return toDateTimeISOStringFormat(new Date(date)).replace("Z", "");
};

export const toFormattedDate = (date) => {
  if (!date) return null;
  const d = new Date(date);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return encodeURIComponent(`${yyyy}/${mm}/${dd} ${hh}:${mi}`);
};

export const buildPositionsUrl = ({
  vehicleId,
  groupId,
  startDate,
  endDate,
  onlyEvents,
  pageNumber = 1,
  pageSize = 10,
  lastReceived,
}) => {
  if (!vehicleId) return null;

  const query = buildPositionsQuery({
    vehicleId,
    groupId,
    startDate: formatDateForQuery(startDate),
    endDate: formatDateForQuery(endDate),
    onlyEvents,
    pageNumber,
    pageSize,
    lastReceived,
  });

  return query
    ? `${API_URLS.REPORTS}/vehicle-positions/positions?${query}`
    : null;
};
